import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/hooks/useProfile";
import { fetchMyClinicRole, toAppRole } from "@/lib/team/role";

export type AppRole = "admin" | "veterinarian" | "receptionist" | "groomer" | "user";

/** Role in the CURRENT clinic (owner comes from the account). */
export function useRole() {
  const { user } = useAuth();
  const { data: profile } = useProfile();
  const clinicId = profile?.current_clinic_id ?? null;

  return useQuery({
    queryKey: ["user-role", user?.id ?? null, clinicId],
    queryFn: async () => {
      if (!user || !clinicId) return null;
      try {
        return toAppRole(await fetchMyClinicRole(clinicId));
      } catch (error) {
        console.error("Error fetching user role:", error);
        return null;
      }
    },
    enabled: !!user && !!clinicId,
    staleTime: 1000 * 60 * 5,
  });
}

export function useIsAdmin() {
  const { data: role, isLoading } = useRole();
  return { isAdmin: role === "admin", isLoading };
}
